/** Sistemas de producto AGDYSA (selector en CMS Usuarios). */
export const PLATFORM_SYSTEMS = [
  { id: "website", label: "Website (CMS)" },
  { id: "academia", label: "Academia" },
  { id: "medicina", label: "Medicina (SIGMO)" },
  { id: "sigmo-saas", label: "SIGMO SaaS comercial" },
];

export const ALL_PLATFORM_SYSTEM_IDS = PLATFORM_SYSTEMS.map((s) => s.id);

export function systemsForRole(role, existing) {
  if (role === "owner") return [...ALL_PLATFORM_SYSTEM_IDS];
  if (role === "medico") return ["medicina"];
  if (Array.isArray(existing) && existing.length) {
    const allowed = new Set(ALL_PLATFORM_SYSTEM_IDS);
    const next = existing.filter((id) => allowed.has(id));
    return next.length ? next : ["website"];
  }
  return ["website"];
}

export function needsSystemSelector(role) {
  return role === "admin" || role === "editor";
}
